import React from "react";
import './Footer.css';
import logo from './logoBiale.png';

export default function Footer(){
	return(
		<div className='footer'>
			<div className='oneOfThree'>
				<p className='text'>Ignacy Mermer</p>
			</div>
			<div className='oneOfThree'>
				<img
					src={logo}
					className='logoFooter'
				/>
			</div>
			<div className='oneOfThree'>
				<p className='text'>IX Liceum im. C. K. Norwida w Częstochowie</p>
				<p className='text'>Konkurs "Zobaczyć matematykę"</p>
			</div>
		</div>
	);
}